<template>
	<div class="view-list">
		<v v-if="isVerticalScreen()" />
		<h v-else />
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import H from './H.vue';
	import V from './V.vue';
	export default {
		name: 'List',
		components: {
			H,
			V
		},
		data() {
			return {
				
			}
		},
		methods: {
			...mapGetters(["isVerticalScreen"]),
		}
	}
</script>
<style scoped lang="less">
	.view-list {
		width: 100%;
	}
</style>